var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mit-my-storage-page mit-page"},[_vm._v(" List current user's storage here ")])
}
var staticRenderFns = []

export { render, staticRenderFns }